import { render, staticRenderFns } from "./dialogUserPolicy.vue?vue&type=template&id=adc2c40e&scoped=true"
import script from "./dialogUserPolicy.vue?vue&type=script&lang=js"
export * from "./dialogUserPolicy.vue?vue&type=script&lang=js"
import style0 from "./dialogUserPolicy.vue?vue&type=style&index=0&id=adc2c40e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc2c40e",
  null
  
)

export default component.exports